module.exports = __webpack_public_path__ + "img/tesla_1920.a1011698.png";